module.exports = __webpack_public_path__ + "img/SINGLE DEVICE SX GREEN.8e87ff1.svg";